export enum TrialViewModes {
  STAT = 'stat',
  RESULTS = 'results',
  LATEST = 'latest'
}
